export default "__VITE_ASSET__D8ZZNpq5__"